import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AgentPanelService } from '../agent-panel.service';

@Component({
  selector: 'app-agent-launcher-button',
  templateUrl: './agent-launcher-button.component.html',
  styleUrls: ['./agent-launcher-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AgentLauncherButtonComponent {
  private readonly agentPanel = inject(AgentPanelService);
  protected readonly isOpen = this.agentPanel.isOpen;

  protected toggle(): void {
    this.agentPanel.toggle();
  }
}
